import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { getClassNameFactory } from "../../utilities/classNames";
import AlertBanner, { AlertBannerType } from "../AlertBanner";
import { MultiStatusBannerStatus } from "./MultiStatusBannerTypes";
import classNames from "classnames";

var MultiStatusBanner = function MultiStatusBanner(_ref) {
  var status = _ref.status,
      loadingProps = _ref.loadingProps,
      successProps = _ref.successProps,
      errorProps = _ref.errorProps,
      buttonText = _ref.buttonText,
      buttonOnClick = _ref.buttonOnClick,
      className = _ref.className,
      headingRank = _ref.headingRank;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      shouldShowAlertBanner = _useState2[0],
      setShouldShowAlertBanner = _useState2[1];

  var getClassName = getClassNameFactory(MultiStatusBanner.displayName);
  var bannerType = AlertBannerType.INFORMATION;
  var title = loadingProps.title;
  var link = loadingProps.link;
  var text = loadingProps.text;
  useEffect(function () {
    setShouldShowAlertBanner(true);
  }, [status]);

  var handleCloseButtonClick = function handleCloseButtonClick() {
    if (buttonOnClick) {
      buttonOnClick();
    }

    setShouldShowAlertBanner(false);
  };

  switch (status) {
    case MultiStatusBannerStatus.loading:
      break;

    case MultiStatusBannerStatus.success:
      bannerType = AlertBannerType.CONFIRMATION;
      title = successProps.title;
      text = successProps.text;
      link = successProps.link;
      break;

    case MultiStatusBannerStatus.error:
      bannerType = AlertBannerType.WARNING;
      title = errorProps.title;
      text = errorProps.text;
      link = errorProps.link;
      break;

    default:
      return null;
  }

  return /*#__PURE__*/React.createElement(AlertBanner, {
    bannerType: bannerType,
    title: title,
    link: link,
    button: {
      buttonText: buttonText,
      onClick: handleCloseButtonClick
    },
    shouldShowAlertBanner: shouldShowAlertBanner,
    className: classNames(getClassName(), className),
    headingRank: headingRank
  }, text);
};

MultiStatusBanner.displayName = "MultiStatusBanner";
export default MultiStatusBanner;